import React, { useState, useEffect } from "react";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";
import { Card, CardContent } from "../components/ui/card";
import BalanceCard from "./BalanceCard";
import Menu from './menu';
import axios from '../axiosInstance';
import HighPerformanceAd from "../components/HighPerformanceAd";
import { FaFacebookF, FaXTwitter } from "react-icons/fa6";
import { Sidebar } from "../components/Sidebar";
import { Header } from "../components/Header";
import KpiCards from "../components/KpiCards";
import AdScriptCard from "../components/AdScriptCard";

import { Footer } from "../components/ Footer";
function Toast({ message, type = "error", onClose }) {
  return (
    <div className={`fixed top-6 left-1/2 transform -translate-x-1/2 z-50 px-4 py-3 rounded shadow-lg text-white ${type === "error" ? "bg-red-600" : "bg-green-600"}`}>
      <div className="flex items-center space-x-2">
        <span>{message}</span>
        <button onClick={onClose} className="ml-2 text-white hover:text-gray-300 font-bold">×</button>
      </div>
    </div>
  );
}

export default function Bonus({ onLogout }) {
  const [coinz, setCoinz] = useState(0);
  const [options, setOptions] = useState(0);
  const [selfWeeklyProfit, setSelfWeeklyProfit] = useState(0);
  const [bonuses, setBonuses] = useState([]);
  const [isEligible, setIsEligible] = useState({});
  const [claimed, setClaimed] = useState({});
  const [toast, setToast] = useState({ message: "", type: "" });

  const showToast = (message, type = "error") => {
    setToast({ message, type });
    setTimeout(() => setToast({ message: "", type: "" }), 3000);
  };

  const fetchBonusStatus = async () => {
    try {
      const res = await axios.get('/api/bonus-status', { withCredentials: true });
      setIsEligible(res.data.isEligible);
      setClaimed(res.data.claimed);
    } catch (err) {
      console.error("Error fetching bonus status", err);
    }
  };

  const getUserData = () => {
    axios.get(`/api/user/me`, { withCredentials: true })
      .then((res) => {
        const { coinz, options, systemCoinz, weeklyProfit } = res.data;
        const valeurCalculee = options > 0 ? ((systemCoinz / weeklyProfit) * options) : 0;
        setSelfWeeklyProfit(valeurCalculee);
        setCoinz(coinz);
        setOptions(options);
      })
      .catch((err) => {
        console.error("Erreur de récupération des données utilisateur", err);
      });
  };

  const claimBonus = (bonusId) => {
    if (claimed[bonusId]) return;
    axios.post('/api/bonus/claim', { type: bonusId }, { withCredentials: true })
      .then(() => {
        setClaimed(prev => ({ ...prev, [bonusId]: true }));
        showToast("Bonus claimed successfully", "success");
      })
      .catch(() => {
        showToast("Error claiming bonus");
      });
  };

  useEffect(() => {
    document.title = "Bonus | CoinzUp";
    getUserData();
  
    const fetchBonuses = async () => {
      try {
        const response = await axios.get('/api/bonuses', { withCredentials: true });
        setBonuses(response.data);
        await fetchBonusStatus(); // récupérer statut bonus ici
      } catch (err) {
        console.error("Error fetching bonuses:", err);
      }
    };
  
    fetchBonuses();
  }, []);

  return (
    <>
     <AdScriptCard scriptSrc="//spendharassingwarmly.com/06/24/a0/0624a04d58c0a5ce026b8eb2c26a839e.js" />
    
    <div className="min-h-screen flex flex-col bg-gray-900 text-white font-sans">

    


      {/* Layout global avec Sidebar */}
      <div className="flex flex-1 min-h-[calc(100vh-64px)]">
        <Sidebar onLogout={onLogout}/>
  
        {/* Contenu principal */}
        <main className="flex-1 px-4 sm:px-10 py-8 space-y-10 overflow-auto min-w-0">
        <Header title="Bonus center"  balance={coinz}        optionsOwned={options}        estimatedWeeklyGain={selfWeeklyProfit} />
  
          {/* Toast */}
          {toast.message && (
            <Toast
              message={toast.message}
              type={toast.type}
              onClose={() => setToast({ message: "", type: "" })}
            />
          )}
  
          {/* Pub principale */}
          <HighPerformanceAd keyId="fd5da3543c594f07b73630f461f10613" width={728} height={90} /> 
  
          {/* Liste des bonus */}
          <div className="bg-gray-800 p-5 rounded-lg border border-gray-700 shadow-sm text-gray-300">
            <h2 className="text-lg font-semibold mb-4 text-white">Available Bonuses</h2>
  
            <div className="overflow-x-auto">
              <table className="w-full text-left text-sm">
                <thead className="border-b border-gray-700 text-gray-400">
                  <tr>
                    <th className="px-2 py-2">Bonus</th>
                    <th className="px-2 py-2">Condition</th>
                    <th className="px-2 py-2">Reward</th>
                    <th className="px-2 py-2 text-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {bonuses.map((bonus) => (
                    <tr
                      key={bonus.id}
                      className="border-b border-gray-800 hover:bg-gray-800/50"
                    >
                      <td className="px-2 py-3 text-white font-medium">
                        {bonus.title}
                      </td>
                      <td className="px-2 py-3 text-gray-300">{bonus.description}</td>
                      <td className="px-2 py-3 text-green-500">{bonus._value} Coinz</td>
                      <td className="px-2 py-3 text-right">
                        <Button
                          disabled={!isEligible[bonus.id] || claimed[bonus.id]}
                          onClick={() => claimBonus(bonus.id)}
                          className={`${
                            claimed[bonus.id]
                              ? "bg-gray-700 cursor-not-allowed"
                              : isEligible[bonus.id]
                              ? "bg-green-600 hover:bg-green-700"
                              : "bg-gray-800 cursor-not-allowed"
                          }`}
                        >
                          {claimed[bonus.id] ? "Claimed" : "Claim"}
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
  
          {/* Pub secondaire */}
          <HighPerformanceAd keyId="96e99453a24be0353f2fe26dc0b9b728" width={468} height={60} />
        </main>
      </div>
  
      {/* Footer */}
      <Footer />
    </div>
    </>
  );
  
}
